const Footer = () => {
  return (
    <>
      <footer className="footer bg-2 bg-blackFooter text-center py-10">
        <div className="copyright footer-text">&copy;MIZUKI KAWABE</div>
      </footer>
    </>
  );
};

export default Footer;
